<template>
    <BasePopup v-model="isHmoneyRefundPopupOpen" customClass="custom-popup mn-wd480">
      <div class="popup-header">
        <h3 class="title">H캐시 환불 신청</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div class="popup-body">
        <p class="popup-text">H캐시 환불은 등록하신 환불계좌로만 처리됩니다.</p>
        <p class="popup-text mb24">관리자 확인을 거쳐 <strong class="text-green">영업일 기준 최대 2주 이내에 환불수수료 ({{ hcashRefundInfo.refundFee }}%) 차감 후 입금</strong>됩니다.</p>
        <div class="box-gray">
          <p class="text-black fs18 ta-c">잔여 H캐시 <strong class="text-green font-bold text-break">{{ hcashRefundInfo.hcashAmount.toLocaleString() }}</strong>원</p>
        </div>
        <div class="mt24">
          <table class="tbl-type tbl-type-row">
            <caption>H캐시 환불 최종 정보</caption>
            <colgroup>
              <col style="width: 30%;"/>
              <col/>
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" class="left form">입금 예정액</th>
                <td class="left form fs15">
                  <span class="flex flex-wrap"><strong class="text-green">{{ totalRefund.toLocaleString() }}원</strong> (환불수수료 {{ hcashRefundInfo.refundFee }}% 차감)</span>
                </td>
              </tr>
              <tr>
                <th scope="row" class="left form">환불 계좌정보</th>
                <td class="left form fs15 popup-text">{{ hcashRefundInfo.accountBankNm }} {{ HconCommonUtils.format.account(hcashRefundInfo.account) }}<br/>{{ hcashRefundInfo.accountName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button type="button" @click="handleClose" class="btn btn-outline md">취소</button>
          <button v-if = "totalRefund > 0" type="button" @click="hcashRefundRequest()" class="btn md">환불 신청</button>
        </div>
      </div>
    </BasePopup>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import BasePopup from '@/components/com/HconComBasePopup.vue'
import { usePopup } from '@/composables/hconUsePopup'
import type { HcashRefundInfoDto } from '~/types/hcash/backend-dto-types'
import { HconCommonUtils } from '@/utils/hcon-common-utils'
import { MEMBER_CODE } from '~/constants/hconMessageConstants';

const { showAlert, showConfirm } = usePopup()
const fetchBuilder  = useHconFetchBuilder();

const hcashRefundInfo = ref<HcashRefundInfoDto>({
  userKey: "",        /*사용자고유번호*/
  hcashAmount: 0,          /*환불금액*/
    refundFee: 5,         /*환불수수료*/
    account: "",      /*계좌번호*/
    accountBankCd: "",      /*은행코드*/
    accountBankNm: "",      /*은행명*/
    accountName: "",      /*예금주명*/
});

onMounted(async () => {
  getRefundInformation();
})

const emit = defineEmits(['success','cancel']);
// 팝업
const isHmoneyRefundPopupOpen = ref(true)

const handleClose = () => {
  emit('cancel', 'f');
  isHmoneyRefundPopupOpen.value = false
}

const totalRefund = ref(0)

const hcashRefundRequest = () => {
  resendAlertLayer()
}
const resendAlertLayer = async () => {
    //이니시스 결제창
    const result = await showConfirm({
    title: 'H캐시 환불',
    message: '환불하시겠습니까?',
    confirmText: '확인'
    })

    if(result) {
      fetchBuilder.post<AjaxResult<any>>('/api/v1/mypage/hcash/refund')
      .query()
      .build()
      .execute()
      .then(async (result) => {
            if(result.resultCode == '200') {
              showAlert({
                title: 'H캐시 환불 신청 완료',
                message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9113)
              })

              emit('success', 's');
              isHmoneyRefundPopupOpen.value = false;
            } else {
            } 
      });
    }
}

const getRefundInformation = async () => {
  fetchBuilder.get<AjaxResult<HcashRefundInfoDto>>('/api/v1/mypage/hcash/get-refund-information')
      .query()
      .build()
      .execute()
      .then(async (result) => {
        if(result.data) {
          hcashRefundInfo.value = result.data
          hcashRefundInfo.value.refundFee = 5
          totalRefund.value = Math.ceil(hcashRefundInfo.value.hcashAmount*(100 - hcashRefundInfo.value.refundFee)/100)
        }
      });
}

</script>